/* Horizon Interiores — carrinho: cálculo de frete + totais Pix/cartão
   Carregar no theme.liquid:
     <script src="{{ 'hz-cart.js' | asset_url }}" defer="defer"></script>

   Regra de ouro da aritmética: o Pix é calculado com PISO em centavos
   (Math.floor), igual ao Liquid da PDP e da grade. Nunca round — um centavo
   de diferença entre telas gera ticket de suporte. */

(function () {
  var fmt = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function money(cents) { return 'R$ ' + fmt.format(cents / 100); }
  function digits(v) { return (v || '').replace(/\D/g, ''); }
  function q(root, sel) { return root.querySelector(sel); }

  /* frete escolhido, por sessão — sobrevive à re-renderização do drawer */
  function savedRate() {
    try { return JSON.parse(sessionStorage.getItem('hzCartRate') || 'null'); } catch (e) { return null; }
  }
  function saveRate(rate) {
    try { sessionStorage.setItem('hzCartRate', JSON.stringify(rate)); } catch (e) {}
  }

  /* ── totais ── */
  function render(root) {
    var total = parseInt(root.dataset.total || '0', 10);        // após cupons, sem frete
    var disc = parseFloat(root.dataset.pixDiscount || '10');
    var maxN = parseInt(root.dataset.installments || '12', 10);
    var minI = parseInt(root.dataset.minInstallment || '500', 10);

    var rate = savedRate();
    var ship = rate ? rate.cents : 0;

    /* HZ-FIX (18/09/2026) — economia do Pix calculada sobre o SUBTOTAL dos
       itens (data-pix-base, escrito pelo hz-cart-summary.liquid), e não sobre
       o total já com cupom. É assim que o app Appmax aplica os 10% no checkout;
       com cupom, o valor daqui passa a bater centavo a centavo com o que o
       checkout cobra. Mesma conta do Liquid (7e). Se o atributo não vier
       (snippet antigo), cai na conta anterior: base = total. */
    var pixBase = parseInt(root.dataset.pixBase || '', 10);
    var savings;
    if (isNaN(pixBase)) {
      savings = total - Math.floor(total * (100 - disc) / 100);             // conta antiga, idêntica
    } else {
      savings = Math.min(Math.floor(pixBase * disc / 100), total);         // nunca acima do total (cupom de 100%)
    }
    var pixProducts = total - savings;
    var pixTotal = pixProducts + ship;                          // desconto só nos produtos
    var cardTotal = total + ship;

    var n = Math.max(1, Math.min(maxN, Math.floor(cardTotal / minI) || 1));
    var inst = Math.ceil(cardTotal / n);

    setText(root, '[data-hz-cart-pix]', money(pixTotal));
    setText(root, '[data-hz-cart-savings]', money(savings));
    setText(root, '[data-hz-cart-card]', money(cardTotal));
    setText(root, '[data-hz-cart-inst]', money(inst));

    var instLine = q(root, '.hz-cart__inst');
    if (instLine) {
      instLine.innerHTML = 'ou ' + n + 'x de <span data-hz-cart-inst>' + money(inst) + '</span> sem juros';
    }

    var row = q(root, '[data-hz-cart-ship-row]');
    if (row) {
      row.hidden = !rate;
      if (rate) {
        setText(root, '[data-hz-cart-ship-label]', 'Frete · ' + rate.name);
        setText(root, '[data-hz-cart-ship-value]', rate.cents === 0 ? 'Grátis' : money(rate.cents));
      }
    }

    var note = q(root, '[data-hz-cart-note]');
    if (note) {
      note.textContent = rate
        // HZ-FIX: CEP com máscara na frase do rodapé (vinha "30140071").
        ? 'Frete estimado para ' + String(rate.zip || '').replace(/^(\d{5})(\d{3})$/, '$1-$2') + '. O valor final é confirmado no checkout.'
        : 'O prazo começa após a confirmação do pagamento.';
    }
  }

  function setText(root, sel, text) { var el = q(root, sel); if (el) el.textContent = text; }

  /* ── cotação ── */
  function renderRates(box, rates, zip) {
    // Se o tema re-renderizou o carrinho durante a cotação, o elemento antigo
    // saiu da página — escrever nele jogaria o resultado no vazio. Realoca.
    if (box && !box.isConnected) {
      var vivo = document.querySelector('[data-hz-cart-rates]');
      if (vivo) box = vivo;
    }
    // UI: se estava recolhido no mobile, abre para mostrar o resultado.
    var ship = box.closest && box.closest('[data-hz-cart-ship]');
    if (ship && ship.classList.contains('hz-collapsible')) {
      ship.classList.add('is-open');
      var lb = ship.querySelector('.hz-cart__label');
      if (lb) lb.setAttribute('aria-expanded', 'true');
    }
    if (!rates || !rates.length) {
      // HZ-FIX (03/08/2026): agora só chegamos aqui quando o Shopify REALMENTE
      // respondeu que não há frete para o endereço. Falha técnica tem mensagem
      // própria (ver quote()) — misturar as duas escondeu o bug por semanas.
      box.innerHTML = '<p class="hz-cart__error">Ainda não entregamos neste CEP. Fale com a gente pelo WhatsApp.</p>';
      return;
    }
    var saved = savedRate();
    box.innerHTML = rates.map(function (r, i) {
      var raw = r.price != null ? r.price : r.total_price;
      var cents = typeof raw === 'string' ? Math.round(parseFloat(raw) * 100) : raw;
      var name = r.presentment_name || r.name;
      // HZ-FIX: /cart/shipping_rates.json devolve delivery_days como ARRAY (ex.: [3,5]).
      // Array vazio é truthy em JS e imprimia "· dias úteis" sem número nenhum.
      // delivery_range vem como datas ISO, não como contagem de dias — não serve aqui.
      var days = null;
      if (Array.isArray(r.delivery_days)) {
        if (r.delivery_days.length) days = r.delivery_days.join(' a ');
      } else if (r.delivery_days != null && r.delivery_days !== '') {
        days = r.delivery_days;
      }
      var checked = saved ? (saved.name === name) : i === 0;
      return '<label class="hz-cart__rate">' +
        '<input type="radio" name="hz-cart-rate" value="' + cents + '"' +
          ' data-name="' + name.replace(/"/g, '&quot;') + '"' + (checked ? ' checked' : '') + '>' +
        '<span class="hz-cart__radio" aria-hidden="true"></span>' +
        '<span class="hz-cart__rate-name">' + name + (days ? ' · ' + days + ' dias úteis' : '') + '</span>' +
        '<span class="hz-cart__rate-price' + (cents === 0 ? ' hz-cart__rate-free' : '') + '">' +
          (cents === 0 ? 'Grátis' : money(cents)) + '</span>' +
      '</label>';
    }).join('');

    var checkedInput = box.querySelector('input:checked');
    if (checkedInput) {
      saveRate({ name: checkedInput.dataset.name, cents: parseInt(checkedInput.value, 10), zip: zip });
      document.querySelectorAll('[data-hz-cart]').forEach(render);
    }
  }

  /* HZ-FIX (30/07/2026) — estado obrigatório na cotação.
     A loja recusa /cart/shipping_rates.json sem `shipping_address[province]`:
     devolve HTTP 422 {"province":["Selecione um estado"]}. Sem isso NENHUMA
     cotação voltava — testado no carrinho e antes já no hz-price.js da PDP.
     Como o cliente digita só o CEP, derivamos a UF das faixas oficiais dos
     Correios. Tabela local: nenhuma chamada a serviço externo, nenhuma
     dependência nova. Mesma tabela do hz-price.js, mantida aqui para o
     hz-cart continuar independente. */
  var UF_RANGES = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [78900, 78999, 'RO'], [79000, 79999, 'MS'],
    [80000, 87999, 'PR'], [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];

  function ufFromZip(zip) {
    var prefix = parseInt(zip.slice(0, 5), 10);
    if (isNaN(prefix)) return null;
    for (var i = 0; i < UF_RANGES.length; i++) {
      if (prefix >= UF_RANGES[i][0] && prefix <= UF_RANGES[i][1]) return UF_RANGES[i][2];
    }
    return null;
  }

  /* HZ-FIX (03/08/2026) — cotação assíncrona.
     CAUSA DO BUG "região não atendida" que aparecia em uns aparelhos e em
     outros não: usávamos GET /cart/shipping_rates.json, que a Shopify calcula
     na hora e SUBMETE A THROTTLING. Quando a conta ainda não estava pronta (ou
     a chamada era limitada), a resposta vinha sem `shipping_rates` e o código
     tratava isso como "não há frete" — mesma tela de erro de região sem
     cobertura. Em aparelho/navegador que já tinha cotado aquele CEP, a resposta
     vinha do cache e funcionava. Daí o "no computador dá certo".
     Caminho recomendado pela Shopify, agora implementado:
       1) POST /cart/prepare_shipping_rates.json  → manda calcular
       2) GET  /cart/async_shipping_rates.json    → devolve null enquanto não
          está pronto; repetimos até vir o resultado.
     Só tratamos como "sem cobertura" quando o Shopify devolve uma LISTA VAZIA.
     Falha de rede/tempo esgotado tem mensagem própria. */
  var RATE_POLL_TRIES = 20;      // ~10s no total
  var RATE_POLL_DELAY = 500;     // ms entre tentativas

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function rateQuery(zip, uf) {
    return 'shipping_address%5Bzip%5D=' + zip +
           '&shipping_address%5Bcountry%5D=Brazil' +
           '&shipping_address%5Bprovince%5D=' + uf;
  }

  /* HZ-FIX v3 (03/08/2026) — dois caminhos, e o erro se identifica.
     O caminho novo (prepare + async) é o preferido. Se ele falhar POR QUALQUER
     MOTIVO que não seja endereço inválido, caímos automaticamente no caminho
     antigo (GET com repetição) antes de mostrar erro ao cliente. E todo erro
     carrega um código curto (err.hz) que aparece na mensagem — ex.: "cód. T404"
     = poll do async parou com HTTP 404. Um print do cliente passa a bastar
     para diagnosticar. Códigos: Tnnn=async esgotou (nnn=último HTTP),
     Lnnn=caminho antigo esgotou, R=falha de rede/exceção, Pnnn=prepare falhou. */
  async function fetchRates(zip, uf, onWait) {
    var qs = rateQuery(zip, uf);
    try {
      return await asyncRates(qs, onWait);
    } catch (e) {
      if (e && e.code === 'ADDRESS') throw e;
      try {
        return await legacyRates(qs);
      } catch (e2) {
        if (e2 && !e2.hz) e2.hz = 'R';
        if (e2 && e && e.hz) e2.hz = e.hz + '/' + e2.hz;
        throw e2;
      }
    }
  }

  async function asyncRates(qs, onWait) {
    var jsonHeaders = { Accept: 'application/json' };
    var prep = await fetch('/cart/prepare_shipping_rates.json?' + qs, {
      method: 'POST', headers: jsonHeaders
    });

    // Endereço recusado pela loja (UF/CEP inválido): erro de endereço, não de rede.
    if (prep.status === 422) { var addrErr = new Error('address'); addrErr.code = 'ADDRESS'; throw addrErr; }
    if (!prep.ok && prep.status !== 202) { var pe = new Error('prep'); pe.code = 'TIMEOUT'; pe.hz = 'P' + prep.status; throw pe; }

    var lastStatus = prep.status;
    for (var i = 0; i < RATE_POLL_TRIES; i++) {
      var res = await fetch('/cart/async_shipping_rates.json?' + qs, { headers: jsonHeaders });
      lastStatus = res.status;
      if (res.ok) {
        var data = null;
        try { data = await res.json(); } catch (e) { data = null; }
        // `null` = ainda calculando. Objeto com shipping_rates = resposta final.
        if (data && data.shipping_rates) return data.shipping_rates;
      }
      // Passados ~3s, avisa que ainda está calculando: silêncio longo parece travado.
      if (onWait && i === 5) { try { onWait(); } catch (e) {} }
      await sleep(RATE_POLL_DELAY);
    }
    var toErr = new Error('timeout'); toErr.code = 'TIMEOUT'; toErr.hz = 'T' + lastStatus; throw toErr;
  }

  async function legacyRates(qs) {
    var lastStatus = 0;
    for (var i = 0; i < 6; i++) {
      var res = await fetch('/cart/shipping_rates.json?' + qs, { headers: { Accept: 'application/json' } });
      lastStatus = res.status;
      if (res.status === 422) { var e = new Error('address'); e.code = 'ADDRESS'; throw e; }
      if (res.ok) {
        var data = null;
        try { data = await res.json(); } catch (err) { data = null; }
        if (data && data.shipping_rates) return data.shipping_rates;
      }
      // 429 = limitação da Shopify: espera mais antes de insistir.
      await sleep(res.status === 429 ? 1500 : 700);
    }
    var t = new Error('timeout'); t.code = 'TIMEOUT'; t.hz = 'L' + lastStatus; throw t;
  }

  async function quote(shipBox) {
    var input = q(shipBox, '[data-hz-cart-zip]');
    var box = q(shipBox, '[data-hz-cart-rates]');
    var zip = digits(input && input.value);

    if (zip.length !== 8) {
      box.innerHTML = '<p class="hz-cart__error">Informe um CEP com 8 dígitos.</p>';
      if (input) input.focus();
      return;
    }

    // HZ-FIX: valida o CEP pelas faixas dos Correios e obtém a UF da cotação.
    var uf = ufFromZip(zip);
    if (!uf) {
      box.innerHTML = '<p class="hz-cart__error">CEP não reconhecido. Confira os 8 dígitos.</p>';
      if (input) input.focus();
      return;
    }

    // HZ-FIX (03/08/2026): uma cotação por vez. Como agora a cotação pode levar
    // alguns segundos, dois toques no botão (ou o re-render do drawer chamando
    // init()) disparavam consultas concorrentes que se sobrescreviam na tela.
    if (shipBox.dataset.hzQuoting === '1') return;
    shipBox.dataset.hzQuoting = '1';

    box.textContent = 'Calculando…';
    try { localStorage.setItem('hzCartZip', zip); } catch (e) {}

    try {
      /* 1) endpoint do app de frete, quando existe */
      if (window.HZ_SHIPPING_ENDPOINT) {
        try {
          var res = await fetch(window.HZ_SHIPPING_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ zip: zip })
          });
          renderRates(box, (await res.json()).rates, zip);
        } catch (e) {
          box.innerHTML = '<p class="hz-cart__error">Não conseguimos calcular agora. Toque em calcular de novo.</p>';
        }
        return;
      }

      /* 2) Ajax Cart API — no carrinho não precisa de item temporário */
      try {
        renderRates(box, await fetchRates(zip, uf, function () {
          box.textContent = 'Ainda calculando… só um instante.';
        }), zip);
      } catch (e) {
        box.innerHTML = e && e.code === 'ADDRESS'
          ? '<p class="hz-cart__error">Não conseguimos validar esse CEP. Confira os 8 dígitos.</p>'
          : '<p class="hz-cart__error">Não conseguimos calcular agora. Toque em calcular de novo. <span class="hz-cart__errcode">(cód. ' + ((e && e.hz) || 'R') + ')</span></p>';
      }
    } finally {
      shipBox.dataset.hzQuoting = '0';
    }
  }

  /* ── eventos (delegados: o drawer é re-renderizado a cada mudança) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hz-cart-zip-submit]');
    if (btn) { quote(btn.closest('[data-hz-cart-ship]')); return; }
  });

  document.addEventListener('change', function (e) {
    var radio = e.target.closest('input[name="hz-cart-rate"]');
    if (!radio) return;
    var zipInput = document.querySelector('[data-hz-cart-zip]');
    saveRate({
      name: radio.dataset.name,
      cents: parseInt(radio.value, 10),
      zip: digits(zipInput && zipInput.value)
    });
    document.querySelectorAll('[data-hz-cart]').forEach(render);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-hz-cart-zip]');
    if (!input) return;
    e.preventDefault();
    quote(input.closest('[data-hz-cart-ship]'));
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-hz-cart-zip]');
    if (!input) return;
    var d = digits(input.value).slice(0, 8);
    input.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  });

  /* ── frete recolhido no mobile ──
     APENAS INTERFACE: nenhuma conta de preço passa por aqui. Abaixo de 750px o
     bloco de frete nasce como uma linha só ("Calcular frete e prazo ▾") e abre
     ao toque, para não comer a altura da lista de produtos no drawer.
     É melhoria progressiva: a classe `hz-collapsible` é adicionada por JS, e o
     CSS só esconde o miolo quando ela existe. Sem JS, o bloco fica aberto como
     antes. Nasce ABERTO quando já há uma cotação na tela — quem acabou de
     calcular não deve ver o resultado sumir.                                  */
  function initShipToggle() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('[data-hz-cart-ship]').forEach(function (box) {
      if (box.dataset.hzToggle) return;
      box.dataset.hzToggle = '1';
      var label = box.querySelector('.hz-cart__label');
      if (!label) return;
      /* HZ-FIX 03/11: na camada vidro (hz-vidro.css) o CEP é pílula sempre aberta e o rótulo é só
         para leitor de tela (position: absolute); não vira botão nem recolhe. */
      if (window.getComputedStyle(label).position === 'absolute') return;
      var rates = box.querySelector('[data-hz-cart-rates]');
      var aberto = !!(rates && rates.children.length);
      box.classList.add('hz-collapsible');
      box.classList.toggle('is-open', aberto);
      label.setAttribute('role', 'button');
      label.setAttribute('tabindex', '0');
      label.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      var toggle = function (e) {
        e.preventDefault();
        var open = box.classList.toggle('is-open');
        label.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var i = box.querySelector('[data-hz-cart-zip]'); if (i) i.focus(); }
      };
      label.addEventListener('click', toggle);
      label.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') toggle(e);
      });
    });
  }

  /* ── init + re-init após o tema re-renderizar o carrinho ── */
  function init() {
    initShipToggle();
    document.querySelectorAll('[data-hz-cart]').forEach(function (root) {
      render(root);
      var input = q(root, '[data-hz-cart-zip]');
      if (input && !input.value) {
        try {
          var z = localStorage.getItem('hzCartZip');
          if (z) {
            input.value = z.slice(0, 5) + '-' + z.slice(5);
            quote(root.querySelector('[data-hz-cart-ship]'));
          }
        } catch (e) {}
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  /* O Dawn troca o HTML do carrinho por sections rendering; reagimos a isso. */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches && n.matches('[data-hz-cart]') || n.querySelector && n.querySelector('[data-hz-cart]'))) {
          init();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();